/**
 * Data layer for `hourly-data-widget-clicks-conversions-cr-epc-cost`. Thin typed fetch wrappers over /api/v1/hourly-data-widget-clicks-conversions-cr-epc-cost.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface HourlyDataWidgetClicksConversionsCrEpcCostRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListHourlyDataWidgetClicksConversionsCrEpcCostResponse {
	count: number;
	items: HourlyDataWidgetClicksConversionsCrEpcCostRow[];
}

export interface CreateHourlyDataWidgetClicksConversionsCrEpcCostBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/hourly-data-widget-clicks-conversions-cr-epc-cost";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListHourlyDataWidgetClicksConversionsCrEpcCostResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListHourlyDataWidgetClicksConversionsCrEpcCostResponse>(res);
}

export async function create(body: CreateHourlyDataWidgetClicksConversionsCrEpcCostBody): Promise<HourlyDataWidgetClicksConversionsCrEpcCostRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<HourlyDataWidgetClicksConversionsCrEpcCostRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys = {
	all: ["hourly-data-widget-clicks-conversions-cr-epc-cost"] as const,
	list: () => [...hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys.all] as const,
	detail: (id: string) => [...hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys.all, id] as const,
};
